import { useState } from "react";
import { loadStripe } from "@stripe/stripe-js";
import { Elements } from "@stripe/react-stripe-js";

import { STRIPE_KEY } from "../helpers";

import Alert from "../components/Alert";

import Order from "./Order";
import Review from "./Review";
import Receipt from "./Receipt";

const stripePromise = loadStripe(STRIPE_KEY);

export default function Donate() {
	const [status, setStatus] = useState(3);

	/*
    0 - error
    1 - Receipt
    2 - Review
		3 - Order
  */

	const handleStatus = (status) => {
		setStatus(status);
	};

	return (
		<>
			{status === 0 ? (
				<Alert
					data={{
						type: "error",
						text: "An error has occurred.",
					}}
				/>
			) : status === 1 ? (
				<Receipt handleStatus={handleStatus} />
			) : status === 2 ? (
				<Elements stripe={stripePromise}>
					<Review handleStatus={handleStatus} />
				</Elements>
			) : (
				<Order handleStatus={handleStatus} />
			)}
		</>
	);
}
